import { Link } from "react-router-dom";

interface VideoCardProps {
  id: string;
  title: string;
  thumbnail: string;
  duration: string;
  views: number;
  score: number;
  category: string;
  categorySlug: string;
  episodes?: number;
}

function formatViews(views: number): string {
  if (views >= 10000000) return `${(views / 10000000).toFixed(1)}千万`;
  if (views >= 10000) return `${(views / 10000).toFixed(1)}万`;
  return views.toString();
}

export default function VideoCard({
  id,
  title,
  thumbnail,
  duration,
  views,
  score,
  category,
  categorySlug,
  episodes,
}: VideoCardProps) {
  return (
    <Link
      to={`/article/${id}`}
      className="group block cursor-pointer"
      data-product-shop
    >
      <div className="relative overflow-hidden rounded-lg aspect-video bg-background-200">
        <img
          src={thumbnail}
          alt={title}
          title={title}
          className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
          width="640"
          height="360"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300">
          <div className="absolute bottom-3 left-3 right-3 flex items-center justify-center">
            <div className="w-12 h-12 flex items-center justify-center bg-white/90 rounded-full">
              <i className="ri-play-fill text-primary-600 text-2xl ml-0.5"></i>
            </div>
          </div>
        </div>
        <span className="absolute bottom-2 right-2 bg-black/75 text-white text-xs px-2 py-0.5 rounded font-label">
          {duration}
        </span>
        {score >= 9 && (
          <span className="absolute top-2 left-2 bg-primary-500 text-white text-xs px-2 py-0.5 rounded font-label">
            {score}分
          </span>
        )}
      </div>
      <div className="mt-3">
        <h3 className="text-sm font-medium text-foreground-900 line-clamp-2 leading-snug group-hover:text-primary-600 transition-colors">
          {title}
        </h3>
        <div className="flex items-center gap-3 mt-1.5 text-xs text-foreground-500">
          <span>{formatViews(views)}次播放</span>
          <span className="flex items-center gap-0.5">
            <i className="ri-star-fill text-secondary-500 text-xs"></i>
            {score}
          </span>
          {episodes && <span>共{episodes}集</span>}
        </div>
        <Link
          to={`/category/${categorySlug}`}
          className="inline-block mt-1.5 text-xs px-2 py-0.5 rounded bg-secondary-100 text-secondary-700 hover:bg-secondary-200 transition-colors cursor-pointer"
        >
          {category}
        </Link>
      </div>
    </Link>
  );
}